import React, { useState } from "react";
import { storage, db } from "../../firebase";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { doc, setDoc } from "firebase/firestore";

const WebsiteConfigure = () => {
  const [backgroundColor, setBackgroundColor] = useState("#ffffff");
  const [logo, setLogo] = useState(null);
  const [sliderImages, setSliderImages] = useState([]);
  const [cardImages, setCardImages] = useState([]);
  const [message, setMessage] = useState("");

  const handleImageUpload = async (file, path) => {
    const storageRef = ref(storage, path);
    await uploadBytes(storageRef, file);
    const url = await getDownloadURL(storageRef);
    console.log(`Uploaded ${file.name} to ${path}: ${url}`);
    return url;
  };

  const handleSave = async () => {
    try {
      const configRef = doc(db, "admin", "siteSettings");

      const logoUrl = logo
        ? await handleImageUpload(logo, `logo/${logo.name}`)
        : null;

      const sliderUrls = await Promise.all(
        sliderImages.map((img) => handleImageUpload(img, `slider/${img.name}`))
      );

      const cardUrls = await Promise.all(
        cardImages.map((img) => handleImageUpload(img, `cards/${img.name}`))
      );

      await setDoc(configRef, {
        backgroundColor,
        logoUrl,
        sliderImages: sliderUrls,
        cardImages: cardUrls,
      });

      setMessage("Configuration saved successfully!");
    } catch (err) {
      setMessage("Error saving configuration: " + err.message);
    }
  };

  return (
    <div className="container py-5">
      <h2 className="mb-4">Website Configuration</h2>

      <div className="mb-3">
        <label className="form-label">Background Color</label>
        <input
          type="color"
          className="form-control form-control-color"
          value={backgroundColor}
          onChange={(e) => setBackgroundColor(e.target.value)}
        />
      </div>

      <div className="mb-3">
        <label className="form-label">Upload Logo</label>
        <input
          type="file"
          className="form-control"
          onChange={(e) => setLogo(e.target.files[0])}
        />
      </div>

      <div className="mb-3">
        <label className="form-label">Upload Slider Images</label>
        <input
          type="file"
          className="form-control"
          multiple
          onChange={(e) => setSliderImages(Array.from(e.target.files))}
        />
      </div>

      <div className="mb-3">
        <label className="form-label">Upload Card Images</label>
        <input
          type="file"
          className="form-control"
          multiple
          onChange={(e) => setCardImages(Array.from(e.target.files))}
        />
      </div>

      <button className="btn btn-primary w-100" onClick={handleSave}>
        Save Configuration
      </button>

      {message && <div className="alert alert-info mt-3">{message}</div>}
    </div>
  );
};

export default WebsiteConfigure;
